/**
 * Close Wireless Web integration.
*/
export default function close() {
    return window.webPosSalesSdk.closeIFrame();
}